import { render, staticRenderFns } from "./order_reactivate.vue?vue&type=template&id=b67ff9cc&lang=pug"
import script from "./order_reactivate.vue?vue&type=script&lang=js"
export * from "./order_reactivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports